import * as React from "react";
import { ISessionState } from "source/models/session/sessionState";
import { ReportType } from "ui/Scripts/source/models/enums";
import { IReportItem } from "source/models/report/reportItem";
import { PageReport } from "source/components/framework/Report/PageReport";
import { IRiskPageFilterLists, IRiskPageFilterState } from "./RiskPageUtils";
import { useEffect, useState } from "react";
import { RiskPageReportHtml } from "./RiskPageReportHtml";

interface IRiskPageReportProp extends IRiskPageFilterLists, IRiskPageFilterState {
    sessionState: ISessionState;
    companyId: string;
    reports: IReportItem[];
    reportId: string;
    dataId?: string;
    showSidePanel: boolean;
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
    onChangeShowSidePanel: (show: boolean) => void;
}

interface IRiskPageReportState {
    report: IReportItem;
}

export const RiskPageReport = (props: IRiskPageReportProp) => {
    const [state, setState] = useState<IRiskPageReportState>({
        report: props.reportId
            ? props.reports.find(i => i.id === props.reportId)
            : null,
    });

    useEffect(() => {
        setState({
            report: props.reportId
                ? props.reports.find(i => i.id === props.reportId)
                : null,
        });
    }, [props.reportId, props.reports, props.companyId, props.dataId]);

    return (
        <PageReport
            isLoading={false}
            report={state.report}
            reportGenerated={null}
            reportDataUri={""}
            htmlReport={
                <RiskPageReportHtml
                    sessionState={props.sessionState}
                    companyId={props.companyId}
                    riskTypes={props.riskTypes}
                    units={props.units}
                    states={props.states}
                    riskCategories={props.riskCategories}
                    riskProcesses={props.riskProcesses}
                    riskStandards={props.riskStandards}
                    riskStakeholders={props.riskStakeholders}
                    residualRisks={props.residualRisks}
                    riskTreatmentStates={props.riskTreatmentStates}
                    handlers={props.handlers}
                    owners={props.owners}
                    selectedRiskTypeIds={props.selectedRiskTypeIds}
                    selectedUnitIds={props.selectedUnitIds}
                    selectedStateIds={props.selectedStateIds}
                    selectedRiskCategoryIds={props.selectedRiskCategoryIds}
                    selectedRiskProcessIds={props.selectedRiskProcessIds}
                    selectedRiskStandardIds={props.selectedRiskStandardIds}
                    selectedRiskStakeholderIds={props.selectedRiskStakeholderIds}
                    selectedResidualRiskIds={props.selectedResidualRiskIds}
                    selectedRiskTreatmentStateIds={props.selectedRiskTreatmentStateIds}
                    selectedHandlerUserCodes={props.selectedHandlerUserCodes}
                    selectedOwners={props.selectedOwners}
                    report={state.report}
                    sortColumn={state.report
                        ? state.report.sortColumn
                        : ""}
                    sortOrderIsAsc={state.report
                        ? state.report.sortOrderIsAsc
                        : true}
                    showSidePanel={props.showSidePanel}
                    onSetSortData={props.onSetSortData}
                    onChangeShowSidePanel={props.onChangeShowSidePanel}
                />
            }
            hidePageTitle={state.report?.type === ReportType.Html}
            sortingDisabled={true}
            onSetSortData={props.onSetSortData}
        />
    );
};
